import {cache0} from "../../../../../utils/cache0";

export const isMobile = cache0(() => {
    const mobileRegEx = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
    return mobileRegEx.test(navigator.userAgent);
});
